module.exports = __webpack_public_path__ + "static/img/4.e0c0742.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/4.png
// module id = fcjL
// module chunks = 0